import { render, staticRenderFns } from "./BuyItemUpdate.vue?vue&type=template&id=74882492&scoped=true&"
import script from "./BuyItemUpdate.vue?vue&type=script&lang=js&"
export * from "./BuyItemUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BuyItemUpdate.vue?vue&type=style&index=0&id=74882492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74882492",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
